import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import "./menu.css";
import { useEffect } from "react";
import Logo from "./../assets/img/union_logo_white.png";
import { logout } from "../store/actions/authActions";

export default function Header() {
  const [isScrolled, setIsScrolled] = React.useState(false);
  const [bar, setBar] = React.useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = React.useState(false);
  const [outside, setOutside] = React.useState("outside");
  const openDrawer = () => {
    setBar(!bar);
  };
  const dispatch = useDispatch();
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const storedUser = localStorage.getItem("user");
  const [currentPosition, setCurrentPosition] = useState(0);
  const closeDrawer = () => setIsDrawerOpen(false);
  const [up, setUp] = useState(true);
  useEffect(() => {
    if (!isLoggedIn && storedUser) {
      const userData = JSON.parse(storedUser);
      dispatch({ type: "LOGIN_ADMIN", payload: userData });
    }
  }, [isLoggedIn, dispatch]);
  const location = useLocation();
  React.useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 50;
      if (currentPosition < window.scrollY) {
        setUp(false);
      } else if (currentPosition > window.scrollY) {
        setUp(true);
      }
      setCurrentPosition(window.scrollY);
      setIsScrolled(isScrolled);
    };
    document.addEventListener("scroll", handleScroll);

    return () => {
      document.removeEventListener("scroll", handleScroll);
    };
  }, [location, currentPosition]);

  const handleLogout = () => {
    dispatch(logout());
    setBar(false); // Close the menu after logout
  };

  return (
    <>
      <div
        className={`w-full h-[130px] flex fixed items-center transition-all duration-500 ${
          !isScrolled && !bar
            ? "header-bg"
            : up
            ? "bg-background opacity-100 pointer-events-auto"
            : bar
            ? ""
            : "opacity-0 pointer-events-none"
        } z-[12]`}
      >
        <div className="max-w-[1290px] w-full mx-auto px-[40px] flex items-center justify-between">
          {/* Left side navigation - hidden on tablet and mobile */}
          <div className="flex-1 hidden lg:flex text-xl justify-start items-center space-x-12 font-roboto">
            <Link
              to="/building"
              className={`text-white ${bar ? "opacity-0" : ""} link`}
            >
              THE BUILDING
            </Link>
            <Link
              to="/neighborhood"
              className={`text-white ${bar ? "opacity-0" : ""} link`}
            >
              NEIGHBORHOOD
            </Link>
          </div>

          {/* Center logo */}
          <Link to="/" className="flex-shrink-0">
            <img src={Logo} alt="Logo" className="h-[80px] w-auto" />
          </Link>

          {/* Right side navigation and burger menu */}
          <div className="flex-1 flex justify-end items-center">
            {/* Navigation links - hidden on tablet and mobile */}
            <div className="hidden lg:flex text-xl items-center space-x-12 mr-6">
              <Link
                to="/availability"
                className={`text-white ${bar ? "opacity-0" : ""} link`}
              >
                AVAILABILITY
              </Link>
              <Link
                to="/contact"
                className={`text-white ${bar ? "opacity-0" : ""} link`}
              >
                CONTACT
              </Link>
            </div>
            {/* Burger menu - visible on tablet and mobile */}
            <button
              onClick={openDrawer}
              className="flex-shrink-0 pl-12 mr-0 lg:-mr-6"
            >
              <div className={`${!bar ? "flex flex-col gap-1" : "relative"}`}>
                <div
                  className={`w-[24px] h-[2px] bg-white transition-all duration-300 ${
                    bar ? "hidden" : ""
                  }`}
                ></div>
                <div
                  className={`${
                    !bar ? "w-[20px]" : "w-[26px] rotate-45 top-[1px] relative"
                  } h-[2px] bg-white transition-all duration-300`}
                ></div>
                <div
                  className={`${
                    !bar
                      ? "w-[20px]"
                      : "w-[26px] -rotate-45 -top-[1px] relative"
                  } h-[2px] bg-white transition-all duration-300`}
                ></div>
              </div>
            </button>
          </div>
        </div>
      </div>

      {/* Menu overlay - Mobile and Tablet */}
      <div
        className={`flex w-full h-screen menu-bg transition-all duration-500 justify-center fixed opacity-1 bg-background ${
          !bar ? "hidden -top-[120%] xl:-top-full" : "z-[11] top-0"
        }`}
      >
        <nav className="flex max-lg:h-full max-lg:flex-col max-w-[1272px] mx-auto w-full justify-center px-4 pt-[120px] pb-[70px] gap-2 max-md:pt-[85px] max-sm:pb-[47px]">
          <div className="sm:hidden"></div>
          <ul className="gap-8 font-normal text-2xl lg:text-[32px] -ml-4 lg:leading-normal flex flex-col items-center lg:items-start justify-center text-white">
            <li className="link">
              <a href="/building" className="text-white">
                THE BUILDING
              </a>
            </li>
            <li className="link">
              <a href="/neighborhood" className="text-white">
                NEIGHBORHOOD
              </a>
            </li>
            <li className="link">
              <a href="/availability" className="text-white">
                AVAILABILITY
              </a>
            </li>
            <li className="link">
              <a href="/gallery" className="text-white">
                GALLERY
              </a>
            </li>
            <li className="link">
              <a href="/team" className="text-white">
                TEAM
              </a>
            </li>
            <li className="link">
              <a href="/contact" className="text-white">
                CONTACT
              </a>
            </li>
            {!(!isLoggedIn && !storedUser) ? (
              <>
                <li className="link">
                  <a href="/admin" className="text-white">
                    ADMIN - Update Availability
                  </a>
                </li>
                <li className="link">
                  <a href="/update-gallery" className="text-white">
                    ADMIN - Update Gallery
                  </a>
                </li>
                <li className="link">
                  <button onClick={handleLogout} className="text-white">
                    LOGOUT
                  </button>
                </li>
              </>
            ) : null}
          </ul>
        </nav>
      </div>
    </>
  );
}
